import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBrightnessAutoComponent } from "./med-icon-brightness-auto.component";

@NgModule({
  declarations: [
    MedIconBrightnessAutoComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBrightnessAutoComponent,
  ],
})
export class MedIconBrightnessAutoModule { }
